import { MatTableDataSource, MatPaginator, MatFormFieldModule, MatSliderChange } from '@angular/material';
import { ConfiguracionesService } from '../../../shared/configuraciones.service';
import { Component, ViewChild, OnInit, ViewEncapsulation, ElementRef, Inject, Output, EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { formatDate } from '@angular/common';
import { ResumenTareasService } from 'src/app/services/resumen-tareas.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
export interface DialogData {
  idBanco: string;
  banco: string;
  inicial: string;
}
import html2canvas from 'html2canvas';
import { MatSnackBar } from '@angular/material/snack-bar';


// Uso:


interface PuntoConOrden extends google.maps.LatLngLiteral {
  ordenVisita: number;
}
const tiposVia: Record<string, string> = {
  'KR': 'Carrera', 'CRA': 'Carrera', 'CARRERA': 'Carrera',
  'CL': 'Calle', 'CALLE': 'Calle',
  'DG': 'Diagonal', 'DIAG': 'Diagonal', 'DIAGONAL': 'Diagonal',
  'TV': 'Transversal', 'TRANSV': 'Transversal', 'TRANSVERSAL': 'Transversal',
  'AV': 'Avenida', 'AVEN': 'Avenida', 'AVENIDA': 'Avenida',
  'AK': 'Avenida Kr', 'AC': 'Autopista', 'AUT': 'Autopista',
  'CIRC': 'Circular', 'CIRCUNVALAR': 'Circunvalar',
  'MANZ': 'Manzana', 'MZ': 'Manzana', 'MNZ': 'Manzana'
};
var listaGeoZona: any[] = [];
@Component({
  selector: 'app-dialogGeoDetelle',
  templateUrl: './dialogGeoDetelle.component.html',
  styleUrls: ['./dialogGeoDetelle.component.scss'],
  encapsulation: ViewEncapsulation.None
})
@Injectable()
export class DialogGeoDetelle implements OnInit {
  @Output() accepted = new EventEmitter<void>();
  idBanco: Number;
  vr: Number;
  banco: string;
  isChange = false
  inicial: string;
  map!: google.maps.Map;
  private geozonaActual: google.maps.Polygon | null = null;
  pedidoExpandido: boolean[] = [];
  validateGeo = {
    city: '',
    countryName: '',
    county: '',
    district: '',
    houseNumber: '',
    label: '',
    postalCode: '',
    street: '',
    address: '',
    business: '',
    agency: '',
    latitude: '',
    longitude: '',
    distance: 0,
    score: 0,
    status: false,
    validate: [],
    geoGoogle: null,
    geoHere: null,
    reportes: null,
    validateDistance: 0
  };

  listGeo = {
    originalAddress: '',
    originalAddressIA: '',
    correctedAddress: '',
    correctedAddressIA: '',
    business: '',
    agency: ''
  };

  urlSegura: SafeResourceUrl;

  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;
  radio: number = this.data.VRTIA_ValidateDistance; // Valor inicial del radio


  private circle: any;
  private markercircle: any;
  currentMainImage: any;
  googleMapsApiKey = 'AIzaSyCyd2VvB-GnsyowcGGQZiGLYU3e2rIMeew'; // Reemplaza con tu API key
  streetView: google.maps.StreetViewPanorama;
  constructor(private sanitizer: DomSanitizer, public dialogRef: MatDialogRef<DialogGeoDetelle>,
    @Inject(MAT_DIALOG_DATA) public data: any, private snackBar: MatSnackBar, private configuracionesService: ConfiguracionesService, public toastr: ToastrManager, private resumenService: ResumenTareasService) { }

  // En tu componente
  getAddressComponent(type: string): string {
    if (!this.data.VRTIA_FindClosestBusinessByName.address_components) return '';

    const component = this.data.VRTIA_FindClosestBusinessByName.address_components.find(
      (comp: any) => comp.types.includes(type)
    );

    return '';
  }



  // Copiar dirección completa al portapapeles
  copyAddress(): void {
    const address = this.data.VRTIA_FindClosestBusinessByName.formatted_address ||
      this.data.VRTIA_FindClosestBusinessByName.vicinity;

    navigator.clipboard.writeText(address).then(() => {
      this.snackBar.open('Dirección copiada al portapapeles', 'Cerrar', {
        duration: 3000
      });
    });
  }

  formatTypes(types: string[]): string {
    if (!types) return 'Establecimiento';

    // Filtrar tipos genéricos
    const filteredTypes = types.filter(t =>
      !['point_of_interest', 'establishment'].includes(t)
    );

    // Mapear a nombres más legibles
    const typeNames = filteredTypes.map(t => {
      switch (t) {
        case 'bakery': return 'Panadería';
        case 'food': return 'Comida';
        case 'store': return 'Tienda';
        default: return t;
      }
    });

    return typeNames.join(', ') || 'Establecimiento';
  }

  copyBusinessInfo(): void {
    const business = this.data.VRTIA_FindClosestBusinessByName;
    const info = `
    Nombre: ${business.name}
    Dirección: ${business.formatted_address || business.vicinity}
    Teléfono: ${business.formatted_phone_number || 'No disponible'}
    Tipo: ${this.formatTypes(business.types)}
    Rating: ${business.rating || 'N/A'} (${business.user_ratings_total || 0} reseñas)
    Enlace: ${business.url}
  `;

    navigator.clipboard.writeText(info.trim()).then(() => {
      this.snackBar.open('Información copiada al portapapeles', 'Cerrar', {
        duration: 3000
      });
    });
  }

  copyBusinessUrl(url: string): void {
    navigator.clipboard.writeText(url).then(() => {
      this.snackBar.open('Enlace copiado al portapapeles', 'Cerrar', {
        duration: 3000,
        panelClass: ['success-snackbar']
      });
    }).catch(err => {
      console.error('Error al copiar el enlace:', err);
      this.snackBar.open('Error al copiar el enlace', 'Cerrar', {
        duration: 3000,
        panelClass: ['error-snackbar']
      });
    });
  }

  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  getSafeMapUrl(placeId: string): SafeResourceUrl {
    const url = `https://www.google.com/maps/embed/v1/place?key=${this.googleMapsApiKey}&q=place_id:${placeId}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getPhotoUrl(photoReference: string): string {

    return `https://maps.googleapis.com/maps/api/place/photo?maxwidth=800&photoreference=${photoReference}&key=${this.googleMapsApiKey}`;
  }

  setMainImage(photo: any): void {
    this.currentMainImage = photo;
  }

  ngOnInit(): void {

    //this.pedidoExpandido = new Array(this.data.reportes?.length || 0).fill(false);

    this.inicial = this.data.Address

    console.log("3 this. this.radio  this.radio this.radio init", this.radio)
    this.data.VRTIA_Reportes.forEach(reporte => {
      if (reporte.foto_cliente === 'SI' && reporte.url_foto_cliente) {
        reporte.url_foto_cliente = this.completePhotoUrl(reporte.url_foto_cliente);
      }

      if (reporte.foto_factura === 'SI' && reporte.url_foto_factura) {
        reporte.url_foto_factura = this.completePhotoUrl(reporte.url_foto_factura);
      }
    });




    ///





    ///


  }



  // ...

  async capturarStreetView(): Promise<void> {
    // 1. Esperar a que Street View esté completamente renderizado


    // 2. Configuración especial para WebGL
    const options = {
      useCORS: true,
      allowTaint: true,
      scale: 1,
      logging: true,
      ignoreElements: (element) => {
        // Ignorar elementos que no son parte del Street View
        return !element.classList.contains('gm-street-view');
      }
    };

    try {
      // 3. Capturar el contenedor específico de Street View
      const streetViewContainer = this.mapContainer.nativeElement.querySelector('.gm-street-view');
      const canvas = await html2canvas(streetViewContainer, options);

      // 4. Crear y descargar imagen
      const imageData = canvas.toDataURL('image/jpeg', 0.85);
      const link = document.createElement('a');
      link.href = imageData;
      link.download = 'street-view.jpg';
      link.click();
    } catch (error) {
      console.error('Error al capturar Street View:', error);
      //this.mostrarAlternativa();
    }
  }

  async capturarStreetViewdos(): Promise<void> {
    // 1. Esperar a que Street View esté completamente cargado
    await new Promise(resolve => {
      google.maps.event.addListenerOnce(this.streetView, 'tilesloaded', () => {
        setTimeout(resolve, 1500); // Delay extra para renderizado
      });
    });

    // 2. Localizar el canvas correctamente
    const container = this.mapContainer.nativeElement;
    const streetViewCanvas = container.querySelector('canvas');

    if (!streetViewCanvas) {
      console.error('No se encontró el elemento canvas');
      return;
    }

    // 3. Crear canvas auxiliar
    const canvas = document.createElement('canvas');
    canvas.width = streetViewCanvas.width;
    canvas.height = streetViewCanvas.height;

    try {
      // 4. Dibujar el contenido (con manejo de errores)
      const context = canvas.getContext('2d');
      if (!context) throw new Error('No se pudo obtener contexto 2D');

      context.drawImage(streetViewCanvas, 0, 0);

      // 5. Convertir y descargar
      canvas.toBlob(blob => {
        if (!blob) throw new Error('Error al generar blob');

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `street-view-${new Date().getTime()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 'image/png', 0.9);

    } catch (error) {
      console.error('Error al capturar:', error);
      // Fallback con html2canvas si falla el método directo
      await this.capturarConHtml2Canvas();
    }
  }

  async capturarConHtml2Canvas() {
    const html2canvas = await import('html2canvas');
    const options = {
      useCORS: true,
      allowTaint: true,
      scale: 1,
      logging: true
    };

    const canvas = await html2canvas.default(this.mapContainer.nativeElement, options);
    const image = canvas.toDataURL('image/jpeg', 0.85);

    const link = document.createElement('a');
    link.href = image;
    link.download = 'street-view-fallback.jpg';
    link.click();
  }

  async validarDireccion() {
    /*
    console.log("validarDireccion limpiarDireccion",this.limpiarDireccion( this.data.Address))
    console.log("validarDireccion",this.data.Address)
    let response = await this.resumenService.buscarTareasPorDireccion(
      "makro", "bogota", this.data.Address, "2025-02-01", "2025-03-30"
    ).toPromise();
    console.log("validarDireccion 2",this.data.Address)
    if (!response || response.tareas.length === 0) {
      console.log("validarDireccion 3",this.data.Address)
      response = await this.resumenService.buscarTareasPorDireccion(
        "makro", "bogota",  this.data.Address + "/" +  this.data.Address, "2025-02-01", "2025-03-30"
      ).toPromise();
    }

    */

    if (!this.data.Address || this.data.Address.trim() === '') {
      // Aquí podrías usar un snackbar o mat-error para mostrar feedback

      return;
    }



    const responseGoogle = await this.resumenService.validateAddress(this.limpiarDireccion(this.data.Address) + " ", "", "CO").toPromise();
    this.data.VRTIA_GeoGoogle = responseGoogle

    const responseHere = await this.resumenService.getCoordinates(this.limpiarDireccion(this.data.Address) + " ").toPromise();
    this.data.VRTIA_GeoHere = responseHere

    this.geoCalculo()


  }

  calcularDistancia(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const R = 6371e3; // Radio de la Tierra en metros
    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;
    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (lng2 - lng1) * Math.PI / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distancia en metros
  }

  estanTodosDentroDelRadio(
    puntos: { lat: number, lng: number }[],
    radioMaximoMetros: number
  ): { dentroDelRadio: boolean, distanciaMaxima: number } {

    let distanciaMaxima = 0;

    for (let i = 0; i < puntos.length; i++) {
      for (let j = i + 1; j < puntos.length; j++) {
        const distancia = this.calcularDistancia(
          puntos[i].lat, puntos[i].lng,
          puntos[j].lat, puntos[j].lng
        );

        // Actualizar la distancia máxima encontrada
        if (distancia > distanciaMaxima) {
          distanciaMaxima = distancia;
        }

        if (distancia > radioMaximoMetros) {
          console.warn(`Puntos ${i} y ${j} están a ${distancia.toFixed(2)} metros (más de ${radioMaximoMetros}m)`);
          return { dentroDelRadio: false, distanciaMaxima };
        }
      }
    }

    return { dentroDelRadio: true, distanciaMaxima };
  }

  filtrarListaConGeo(
    puntoReferencia: { lat: number, lng: number },
    distanciaMaximaMetros: number = 50
  ): any[] { // Puedes reemplazar 'any' con un tipo unión específico si lo tienes
    if (this.data.VRTIA_ListaConGeo.length === 0) {
      return [];
    }

    // Separar los elementos excluyendo los type="point"
    const reports = this.data.VRTIA_ListaConGeo.filter(item =>
      item.type === 'report' && item.type !== 'point'
    );

    const otrosTipos = this.data.VRTIA_ListaConGeo.filter(item =>
      item.type !== 'report' && item.type !== 'point'
    );

    // Procesar solo los reports
    const reportsProcesados = this.filtrarReports(reports, puntoReferencia, distanciaMaximaMetros);

    // Combinar los reports filtrados con los otros tipos
    return [...otrosTipos, ...reportsProcesados];
  }

  private filtrarReports(
    reports: any[],
    puntoReferencia: { lat: number, lng: number },
    distanciaMaximaMetros: number
  ): any[] {
    // Filtrar reports válidos (lat ≠ 0)
    const reportsValidos = reports.filter(item => parseFloat(item.lat) !== 0.0);

    if (reportsValidos.length === 0) {
      return []; // No hay reports válidos para filtrar
    }

    // Calcular distancias
    const reportsConDistancia = reportsValidos.map(item => {
      const puntoItem = new google.maps.LatLng(parseFloat(item.lat), parseFloat(item.lng));
      const distancia = google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(puntoReferencia.lat, puntoReferencia.lng),
        puntoItem
      );
      return { item, distancia };
    });

    // Filtrar por distancia
    const reportsDentroRadio = reportsConDistancia
      .filter(r => r.distancia <= distanciaMaximaMetros)
      .map(r => r.item);

    // Si hay reports dentro del radio, devolverlos
    if (reportsDentroRadio.length > 0) {
      return reportsDentroRadio;
    }

    // Si no, devolver el report más cercano
    const reporteMasCercano = reportsConDistancia.reduce((prev, current) =>
      (prev.distancia < current.distancia) ? prev : current
    ).item;

    return [reporteMasCercano];
  }

  filtrarPorDistancia(
    puntoReferencia: { lat: number, lng: number },
    distanciaMaximaMetros: number = 50
  ): any[] {
    // Verificar que la lista original exista


    // Filtrar los puntos que cumplan con las condiciones
    const listaFiltrada = this.data.VRTIA_ListaConGeo.filter(item => {
      // Verificar que tenga coordenadas válidas (latitud no sea 0)
      if (parseFloat(item.lat) === 0.0) return false;

      // Crear objetos LatLng para calcular la distancia
      const puntoItem = new google.maps.LatLng(
        parseFloat(item.lat),
        parseFloat(item.lng)
      );
      const puntoRef = new google.maps.LatLng(
        puntoReferencia.lat,
        puntoReferencia.lng
      );

      // Calcular distancia y comparar
      const distancia = google.maps.geometry.spherical.computeDistanceBetween(
        puntoRef,
        puntoItem
      );

      return distancia <= distanciaMaximaMetros;
    });

    return listaFiltrada;
  }

  updateCircle(): void {
    // Eliminar círculo existente si hay uno
    if (this.circle) {
      this.circle.setMap(null);
    }
    console.log("this.this.radio this.radio", this.radio)
    console.log("this.markercircle", this.markercircle)
    // Crear nuevo círculo con el radio actual
    this.circle = new google.maps.Circle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      map: this.map,
      center: this.markercircle.getPosition(),
      radius: this.radio
    });

    console.log("2.circle")
    console.log("2 updateCircle")
    // Ajustar el zoom para que el círculo sea visible

    console.log("3 this.circle", this.circle)
    this.map.fitBounds(this.circle.getBounds());
    console.log("3 updateCircle")

    const listaFiltrada = this.filtrarListaConGeo({ lat: this.data.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: this.data.VRTIA_GeoGoogle.result.geocode.location.longitude }, this.radio);

    const dentroDelRadio = this.estanTodosDentroDelRadio(listaFiltrada, this.radio);

    this.data.VRTIA_Status = dentroDelRadio.dentroDelRadio
    this.data.VRTIA_ValidateDistance = dentroDelRadio.distanciaMaxima
    if (dentroDelRadio.dentroDelRadio) {
      this.data.VRTIA_Score = 100.0
    } else {
      this.data.VRTIA_Score = 70.0
    }

    const colorGen = new ColorGenerator();
    const color = colorGen.generarColorFosforescenteOscuro();
    this.addGeozonaGeo(listaFiltrada, color, this.map);
  }

  onRadioChange(event?: MatSliderChange): void {
    if (event) {
      console.log("ingreso antes  this. this.radio  this.radio this.radio", this.radio)
      this.radio = event.value || this.data.VRTIA_ValidateDistance;
      console.log("ingreso 3 this. this.radio  this.radio this.radio", this.radio)
    }
    // Aquí puedes agregar lógica para actualizar el mapa u otros componentes
    // según el nuevo radio

    this.updateCircle();
  }

  togglePedido(index: number): void {
    this.pedidoExpandido[index] = !this.pedidoExpandido[index];
  }

  completePhotoUrl(storedUrl: string): string {
    // Extraer partes existentes de la URL
    const urlParts = storedUrl.split('/o/Fotos%2F');
    if (urlParts.length !== 2) return storedUrl; // Si no coincide el formato

    const baseUrl = urlParts[0] + '/o/Fotos%2F';
    const restOfUrl = urlParts[1];

    // Obtener negocio y agencia de localStorage
    const negocio = localStorage.getItem('negocio') || 'defaultNegocio';
    const agencia = localStorage.getItem('agencia') || 'defaultAgencia';

    // Insertar negocio y agencia en la ruta
    const datePart = restOfUrl.split('%2FE')[0];
    const filePart = restOfUrl.split('%2FE')[1];

    // Reconstruir URL completa
    return `${baseUrl}${datePart}%2F${negocio}%2F${agencia}%2FE${filePart}`;
  }

  actualizarElementoPorTipo(
    type: string,
    updates: { lat?: number; lng?: number; ordenTarea?: number }
  ): boolean {
    const index = this.data.VRTIA_ListaConGeo.findIndex(item => item.type === type);

    if (index === -1) return false;

    this.data.VRTIA_ListaConGeo = [
      ...this.data.VRTIA_ListaConGeo.slice(0, index),
      {
        ...this.data.VRTIA_ListaConGeo[index],
        ...updates  // Sobrescribe solo las propiedades proporcionadas
      },
      ...this.data.VRTIA_ListaConGeo.slice(index + 1)
    ];

    return true;
  }

  onNoClick() {

    const panorama = this.map.getStreetView(); // Obtiene el Street View vinculado al mapa

    if (panorama) {
      const position = panorama.getPosition();
      const pov = panorama.getPov();

      const lat = position.lat();
      const lng = position.lng();
      const heading = pov.heading;
      const pitch = pov.pitch;

      const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}&heading=${heading}&pitch=${pitch}`;

      // Si querés usarlo dentro de Angular, sanitizá la URL si la vas a mostrar en iframe (aunque este tipo de link no permite iframe)
      // this.urlSegura = url; // o this.urlSegura = this.sanitizer.bypassSecurityTrustResourceUrl(url);

      console.log("🌐 URL de Street View directa:", url);
    }


    // Uso:
    //capturarMapaComoJPG('   mapContainer'); // Reemplaza con tu ID

    // this.dialogRef.close();
  }





  async onOK(): Promise<void> {
    if (this.inicial != this.data.Address && !this.isChange) {

      this.listGeo.originalAddress = this.data.Address
      this.listGeo.originalAddressIA = this.data.vrtIADireccion
      this.listGeo.correctedAddress = this.data.Address
      this.listGeo.correctedAddressIA = this.limpiarDireccion(this.data.Address)
      this.listGeo.business = localStorage.getItem("negocio");
      this.listGeo.agency = localStorage.getItem("agencia");

      const responsed = await this.resumenService.guardarListaGeo(
        this.listGeo
      ).toPromise();


      var item = this.data

      const radioMaximo = this.radio; // 20 metros


      const listaFiltrada = this.filtrarListaConGeo({ lat: this.data.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: this.data.VRTIA_GeoGoogle.result.geocode.location.longitude }, this.radio);

      const dentroDelRadio = this.estanTodosDentroDelRadio(listaFiltrada, radioMaximo);
      this.validateGeo.status = dentroDelRadio.dentroDelRadio

      item.VRTIA_ListaConGeo = listaGeoZona

      if (listaGeoZona.length > 2) {
        item.status = dentroDelRadio.dentroDelRadio
        item.distance = dentroDelRadio.distanciaMaxima
        if (dentroDelRadio.dentroDelRadio) {
          item.score = 100.0
          this.validateGeo.score = 100.0
        } else {
          item.score = 70.0
          this.validateGeo.score = 70.0
        }

      } else {
        this.validateGeo.status = false
        item.status = false

        if (listaGeoZona.length == 3) {
          item.score = 70.0
          this.validateGeo.score = 70.0
        }

        if (listaGeoZona.length == 2) {
          item.score = 50.0
          this.validateGeo.score = 50.0
        }
        if (listaGeoZona.length == 1) {
          item.score = 20.0
          this.validateGeo.score = 20.0
        }
      }
      this.validateGeo.geoGoogle = item.VRTIA_GeoGoogle;
      this.validateGeo.geoHere = item.geoHere;
      this.validateGeo.reportes = item.reportes;

      if (item.VRTIA_GeoHere && item.VRTIA_GeoHere.items[0] && item.VRTIA_GeoHere.items[0].address) {
        const { address } = item.VRTIA_GeoHere.items[0];

        this.validateGeo.city = address.city;
        this.validateGeo.countryName = address.countryName;
        this.validateGeo.county = address.county;
        this.validateGeo.district = address.district;
        this.validateGeo.houseNumber = address.houseNumber;
        this.validateGeo.label = address.label;
        this.validateGeo.postalCode = address.postalCode;
        this.validateGeo.street = address.street;
        this.validateGeo.validateDistance = radioMaximo
        item.validateDistance = radioMaximo;

        item.city = address.city;
        item.countryName = address.countryName;
        item.county = address.county;
        item.district = address.district;
        item.houseNumber = address.houseNumber;
        item.label = address.label;
        item.postalCode = address.postalCode;
        item.street = address.street;
      }


      this.validateGeo.business = localStorage.getItem("negocio");
      this.validateGeo.agency = localStorage.getItem("agencia");
      this.validateGeo.address = this.limpiarDireccion(item.Address)
      this.validateGeo.longitude = item.Longitude
      this.validateGeo.latitude = item.Latitude

      this.validateGeo.validate = listaGeoZona
      this.validateGeo.distance = dentroDelRadio.distanciaMaxima
      const response = await this.resumenService.guardarValidateGeo(
        this.validateGeo
      ).toPromise();
      this.accepted.emit(); // Solo notifica al padre
      this.dialogRef.close();

    } else {

      this.resumenService.updateGeoByAddress(this.data.vrtIADireccion, {
        status: this.data.status,
        distance: this.data.distance,
        score: this.data.score,
        validateDistance: this.radio,
        geoGoogle: this.data.geoGoogle,
        geoHere: this.data.geoHere,
        validate: this.data.VRTIA_ListaConGeo,
        address: this.data.vrtIADireccion,
        latitude: this.data.VRTIA_GeoGoogle.result.geocode.location.latitude,
        longitude: this.data.VRTIA_GeoGoogle.result.geocode.location.longitude

      }).subscribe({
        next: (response: any) => {

          this.accepted.emit(); // Solo notifica al padre
          this.dialogRef.close();
        },
        error: (err) => {
          this.accepted.emit(); // Solo notifica al padre
          this.dialogRef.close();
        }
      });

    }

    //this.addGeozonaGeo(listaGeoZona, color, mapa);


    /*




    */


  }

  limpiarDireccion(direccion: string): string {
    if (!direccion) return '';

    let texto = direccion.toUpperCase().trim(); // Convertir a mayúsculas y eliminar espacios extra

    // Eliminar cualquier texto después de "/"
    texto = texto.split('/')[0].trim();

    // Reemplazar abreviaturas de tipo de vía
    Object.keys(tiposVia).forEach(abreviatura => {
      const regex = new RegExp(`\\b${abreviatura}\\b`, 'gi'); // Insensible a mayúsculas
      texto = texto.replace(regex, tiposVia[abreviatura]);
    });

    // Eliminar caracteres no deseados como #, -, , y normalizar espacios
    texto = texto.replace(/[#,\-]/g, ' ');

    // 🔹 Nueva regla: Separar letras de números en casos como "78C11" → "78C 11"
    texto = texto.replace(/([0-9])([A-Z])([0-9])/g, '$1$2 $3'); // Ej: 78C11 → 78C 11
    texto = texto.replace(/([A-Z])([0-9])/g, '$1 $2'); // Ej: B78 → B 78 (si es necesario)

    // Reemplazar múltiples espacios seguidos por uno solo
    texto = texto.replace(/\s+/g, ' ').trim();

    return texto;
  }

  focusReporte(reporte: any): void {
    if (this.map && reporte.latTarea && reporte.lonTarea) {
      const position = {
        lat: Number(reporte.latTarea),
        lng: Number(reporte.lonTarea)
      };

      this.map.setCenter(position);
      this.map.setZoom(17);



      new google.maps.Marker({
        position: position,
        map: this.map,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
          scaledSize: new google.maps.Size(32, 32)
        },
        title: reporte.NombredeCliente
      });
    }
  }


  addGeozonaGeo(recorridos: any[], color: string, mapa: google.maps.Map): void {
    // 1. Limpiar geozona anterior si existe

    console.log("detalle lrecorridos ", recorridos)
    if (this.geozonaActual) {
      this.geozonaActual.setMap(null); // Elimina del mapa
      this.geozonaActual = null;
    }



    const puntosValidos = recorridos.filter(location =>
      location.type !== "point" && parseFloat(location.lat) !== 0.0
    );

    if (puntosValidos.length === 0) {
      console.warn("⚠️ No hay puntos válidos para crear la geozona");
      return;
    }

    // 3. Ordenar por ETA (si existe)
    const puntosOrdenados = [...puntosValidos].sort((a, b) =>
      new Date(a.eta || 0).getTime() - new Date(b.eta || 0).getTime()
    );

    // 4. Asignar orden de visita
    const puntosConOrden: PuntoConOrden[] = puntosOrdenados.map((loc, index) => ({
      lat: parseFloat(loc.lat),
      lng: parseFloat(loc.lng),
      ordenVisita: 1,
      ordenTarea: index + 1
    }));

    // 5. Crear y dibujar nueva geozona
    const geozonaCoords = this.createConvexHull(puntosConOrden);

    this.geozonaActual = new google.maps.Polygon({
      paths: geozonaCoords,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: color,
      fillOpacity: 0.3,
      map: mapa // Asignamos directamente al mapa
    });
  }
  private reporteMarker: google.maps.Marker | null = null;
  focusHereResult(item: any): void {
    if (this.map && item.position) {
      this.map.setCenter({
        lat: item.position.lat,
        lng: item.position.lng
      });
      this.map.setZoom(20);

      // Opcional: agregar un marcador temporal
      new google.maps.Marker({
        position: { lat: item.position.lat, lng: item.position.lng },
        map: this.map,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
        }
      });
    }
  }


  createConvexHull(points: google.maps.LatLngLiteral[]): google.maps.LatLngLiteral[] {
    if (points.length < 3) return points;

    // Eliminar puntos duplicados
    const uniquePoints = Array.from(new Set(points.map(p => `${p.lat},${p.lng}`)))
      .map(p => {
        const [lat, lng] = p.split(',');
        return { lat: parseFloat(lat), lng: parseFloat(lng) };
      });

    // Ordenar puntos por latitud y luego por longitud
    const sorted = uniquePoints.sort((a, b) => a.lat === b.lat ? a.lng - b.lng : a.lat - b.lat);

    // Función para calcular el producto cruzado
    const crossProduct = (o: google.maps.LatLngLiteral, a: google.maps.LatLngLiteral, b: google.maps.LatLngLiteral) =>
      (a.lat - o.lat) * (b.lng - o.lng) - (a.lng - o.lng) * (b.lat - o.lat);

    // Construir la parte inferior del convex hull
    const lower: google.maps.LatLngLiteral[] = [];
    for (const point of sorted) {
      while (lower.length >= 2 && crossProduct(lower[lower.length - 2], lower[lower.length - 1], point) < 0) {
        lower.pop();
      }
      lower.push(point);
    }

    // Construir la parte superior del convex hull
    const upper: google.maps.LatLngLiteral[] = [];
    for (const point of sorted.reverse()) {
      while (upper.length >= 2 && crossProduct(upper[upper.length - 2], upper[upper.length - 1], point) < 0) {
        upper.pop();
      }
      upper.push(point);
    }

    // Eliminar el último punto de cada parte porque está duplicado
    upper.pop();
    lower.pop();

    // Combinar las partes inferior y superior
    return lower.concat(upper);
  }
  ngAfterViewInit(): void {

    this.geoCalculo()

  }

  initMap(): void {


    const options: google.maps.MapOptions = {
      center: { lat: this.data.VRTIA_ListaConGeo[0].lat, lng: this.data.VRTIA_ListaConGeo[0].lng }, // 🔹 Centro en Colombia
      zoom: 7 // 🔹 Zoom inicial (ajusta según sea necesario)
    };

    const colorGen = new ColorGenerator();
    const color = colorGen.generarColorFosforescenteOscuro();

    this.map = new google.maps.Map(this.mapContainer.nativeElement, options);
    if (
      this.data &&
      this.data.VRTIA_FindClosestBusinessByName &&
      this.data.VRTIA_FindClosestBusinessByName.geometry &&
      this.data.VRTIA_FindClosestBusinessByName.geometry.location
    ) {
      const marker = new google.maps.Marker({
        map: this.map,
        position: this.data.VRTIA_FindClosestBusinessByName.geometry.location,
        title: this.data.VRTIA_FindClosestBusinessByName.name,
        label: {
          text: this.data.VRTIA_FindClosestBusinessByName.name,
          color: "#000",
          fontSize: "14px",
          fontWeight: "bold"
        }
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `
      <div style="max-width: 320px; font-family: Arial;">
        <h2 style="margin: 0 0 5px 0;">${this.data.VRTIA_FindClosestBusinessByName.name}</h2>
        <p style="margin: 0 0 5px 0;">${this.data.VRTIA_FindClosestBusinessByName.details.formatted_address}</p>
      </div>
    `
      });

      this.mostrarStreetView(marker);

      marker.addListener('click', () => {
        infoWindow.open(this.map, marker);
      });

      // Puedes abrirlo automáticamente si quieres
      infoWindow.open(this.map, marker);

      this.streetView = this.map.getStreetView();

      // Configurar StreetView (opcional)
      this.streetView.setOptions({
        disableDefaultUI: true,
        showRoadLabels: false
      });
    } else {
      console.warn('Ubicación no disponible en los datos proporcionados.');
    }




    console.log("this.data detalle", this.data)
    const lat = Number(this.data.Latitud);
    const lng = Number(this.data.Longitud);

    if (!isNaN(lat) && !isNaN(lng)) {
      this.data.VRTIA_ListaConGeo.push({
        lat: lat,
        lng: lng,
        type: "point"
      });
    } else {
      console.error('Valores de coordenadas no numéricos:', this.data.Latitude, this.data.Longitude);
      // Opcional: puedes asignar valores por defecto o manejar el error
    }


    this.data.VRTIA_ListaConGeo.forEach((reportes, index) => {

      if (reportes.type == "google") {
        console.log("reportes google reportes", reportes)
        console.log("reportes google")
        this.markercircle = new google.maps.Marker({
          position: { lat: reportes.lat, lng: reportes.lng },
          map: this.map,
          draggable: true,
          label: {
            text: index.toString(), // Muestra el número en el centro
            color: "#000", // Color del número
            fontSize: "8px",
            fontWeight: "normal",
          },
          icon: {
            path: "M 0,-15 L 12,10 L -12,10 Z", // 🔺 Triángulo equilátero
            fillColor: "#FFFF", // Amarillo dorado para mejor visibilidad
            fillOpacity: 0.5,
            strokeColor: "orange",
            strokeWeight: 2,
            scale: 1.5, // Ajusta el tamaño según sea necesario
          }
        });

        // Evento dragend para capturar nueva posición
        this.markercircle.addListener("dragend", (event) => {
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();
          this.isChange = true

          this.data.vrtIALatitude = lat
          this.data.vrtIALongitude = lng
          this.data.VRTIA_GeoGoogle.result.geocode.location.latitude = lat
          this.data.VRTIA_GeoGoogle.result.geocode.location.longitude = lng
          //const listaFiltrada = this.filtrarListaConGeo({ lat:this.data.geoGoogle.result.geocode.location.latitude, lng: this.data.geoGoogle.result.geocode.location.longitude }, this.radio);

          this.actualizarElementoPorTipo("google", { lat, lng })

          this.updateCircle()


        });

        console.error('radigo antes de updatecircle:', this.radio);

        this.updateCircle()

        const infoWindow = new google.maps.InfoWindow({
          content: `
              <div style="
                  font-size: 6px;
                  padding: 1px;
                  max-width: 160px;
                  border-radius: 2px;
                  text-align: center;
              ">
                  <h4 style="margin: 0; font-size: 14px;">${this.data.Address}</h4>
                  <p style="margin: 0px 0; font-size: 12px;"><strong>Cliente:</strong> ${this.data.Client}</p>
  
              </div>
          `
        });

        // Hacer zoom y centrar el mapa al hacer clic en el marcador
        this.markercircle.addListener("click", () => {
          this.map.setCenter(this.markercircle.getPosition() as google.maps.LatLng);
          this.map.setZoom(14); // Nivel de zoom al hacer clic
          infoWindow.open(this.map, this.markercircle);
        });
      }

      if (reportes.type == "point") {

        var marker = new google.maps.Marker({
          position: { lat: reportes.lat, lng: reportes.lng },
          map: this.map,
          label: {
            text: index.toString(), // Muestra el número en el centro
            color: "#000", // Color del número
            fontSize: "8px",
            fontWeight: "normal",
          },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            fillColor: color,
            fillOpacity: 0.8,
            strokeColor: color,
            strokeWeight: 2,
            scale: 15, // Tamaño del círculo
          }
        });

        const infoWindow = new google.maps.InfoWindow({
          content: `
              <div style="
                  font-size: 6px;
                  padding: 1px;
                  max-width: 160px;
                  border-radius: 2px;
                  text-align: center;
              ">
                  <h4 style="margin: 0; font-size: 14px;">${this.data.Address}</h4>
                  <p style="margin: 0px 0; font-size: 12px;"><strong>Cliente:</strong> ${this.data.Client}</p>
  
              </div>
          `
        });

        // Hacer zoom y centrar el mapa al hacer clic en el marcador
        marker.addListener("click", () => {
          this.map.setCenter(marker.getPosition() as google.maps.LatLng);
          this.map.setZoom(14); // Nivel de zoom al hacer clic
          infoWindow.open(this.map, marker);
        });


      }



      if (reportes.type == "here") {


        var marker = new google.maps.Marker({
          position: { lat: reportes.lat, lng: reportes.lng },
          map: this.map,
          draggable: true,
          label: {
            text: index.toString(), // Muestra el número en el centro
            color: "#000", // Color del número
            fontSize: "8px",
            fontWeight: "normal",
          },
          icon: {
            path: "M 0,-15 L 14,-5 L 9,12 L -9,12 L -14,-5 Z", // Pentágono
            fillColor: "#FFFF",
            fillOpacity: 0.5,
            strokeColor: "blue",
            strokeWeight: 2,
            scale: 1,
          }
        });


        const infoWindow = new google.maps.InfoWindow({
          content: `
          <div style="
              font-size: 6px;
              padding: 1px;
              max-width: 160px;
              border-radius: 2px;
              text-align: center;
          ">
              <h4 style="margin: 0; font-size: 14px;">${this.data.Address}</h4>
              <p style="margin: 0px 0; font-size: 12px;"><strong>Cliente:</strong> ${this.data.Client}</p>

          </div>
      `
        });

        // Hacer zoom y centrar el mapa al hacer clic en el marcador
        marker.addListener("click", () => {
          this.map.setCenter(marker.getPosition() as google.maps.LatLng);
          this.map.setZoom(14); // Nivel de zoom al hacer clic
          infoWindow.open(this.map, marker);
        });

        marker.addListener("dragend", (event) => {

          this.isChange = true
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();

          this.data.VRTIA_GeoHere.items[0].position.lat = lat
          this.data.VRTIA_GeoHere.items[0].position.lng = lng

          this.actualizarElementoPorTipo("here", { lat, lng })
          //this.data.vrtIALatitude =   lat
          //this.data.vrtIALongitude =  lng

          this.updateCircle()


        });


      }

      if (reportes.type == "report") {



        var marker = new google.maps.Marker({
          position: { lat: reportes.lat, lng: reportes.lng },
          map: this.map,
          label: {
            text: index.toString(), // Muestra el número en el centro
            color: "#000", // Color del número
            fontSize: "8px",
            fontWeight: "normal",
          },
          icon: {
            path: "M -5,-5 L 5,-5 L 5,5 L -5,5 Z",
            fillColor: "#FFFF",
            fillOpacity: 0.5,
            strokeColor: "green", // 🔹 Borde verde si "SI", rojo si no
            strokeWeight: 2, // 🔹 Puedes ajustar el grosor del borde si es necesario
            scale: 3, // Tamaño del círculo
          }
        });


        const infoWindow = new google.maps.InfoWindow({
          content: `
              <div style="
                  font-size: 6px;
                  padding: 1px;
                  max-width: 160px;
                  border-radius: 2px;
                  text-align: center;
              ">
                  <h4 style="margin: 0; font-size: 14px;">${this.data.Address}</h4>
                  <p style="margin: 0px 0; font-size: 12px;"><strong>Cliente:</strong> ${this.data.Client}</p>
    
              </div>
          `
        });

        // Hacer zoom y centrar el mapa al hacer clic en el marcador
        marker.addListener("click", () => {
          this.map.setCenter(marker.getPosition() as google.maps.LatLng);
          this.map.setZoom(14); // Nivel de zoom al hacer clic
          infoWindow.open(this.map, marker);
        });


      }



    });


    console.log("detalle  this.data.listaConGeo", this.data.VRTIA_ListaConGeo)
    const listaFiltrada = this.filtrarListaConGeo({ lat: this.data.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: this.data.VRTIA_GeoGoogle.result.geocode.location.longitude }, this.radio);

    console.log("detalle listaFiltrada", listaFiltrada)
    this.addGeozonaGeo(listaFiltrada, color, this.map);
  }

  getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  mostrarStreetView(marker: google.maps.Marker) {
    // Espera 2 segundos antes de ejecutar
    setTimeout(() => {
      const streetViewService = new google.maps.StreetViewService();
      const radius = 50;

      streetViewService.getPanorama({
        location: marker.getPosition(),
        radius: radius
      }, (data, status) => {
        if (status === google.maps.StreetViewStatus.OK) {
          const panoId = data.location.pano;
          const latLng = data.location.latLng;

          const url = `https://www.google.com/maps/embed/v1/streetview?key=AIzaSyCyd2VvB-GnsyowcGGQZiGLYU3e2rIMeew&location=${latLng.lat()},${latLng.lng()}&pano=${panoId}&heading=0&pitch=0`;
          console.error('ingreso');

          // Asegurate que 'sanitizer' esté inyectado en tu constructor
          // this.urlSegura = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        } else {
          console.error('No se encontró Street View cerca del marcador');
        }
      });
    }, 2000); // 2000 ms = 2 segundos
  }


  geoCalculo(): void {

    listaGeoZona = []
    if (this.data.VRTIA_Reportes.length > 0) {


      this.data.VRTIA_Reportes.forEach(reportes => {

        if (reportes.lonTarea != 0.0) {

          listaGeoZona.push({ lat: reportes.latTarea, lng: reportes.lonTarea, type: "report" })


        }

      });



    }

    listaGeoZona.push({ lat: this.data.VRTIA_GeoGoogle.result.geocode.location.latitude, lng: this.data.VRTIA_GeoGoogle.result.geocode.location.longitude, type: "google" })

    if (this.data.VRTIA_GeoHere.items.length > 0) {
      const reportes = this.data.VRTIA_GeoHere.items[0]; // Solo tomar el primer element
      listaGeoZona.push({ lat: reportes.position.lat, lng: reportes.position.lng, type: "here" });
    }

    this.data.VRTIA_ListaConGeo = listaGeoZona

    this.initMap()
  }



}

class ColorGenerator {
  private usedColors: Set<string> = new Set();

  generarColorFosforescenteOscuro(): string {
    let color: string;
    let attempts = 0; // Evita bucles infinitos

    do {
      // Colores base oscuros pero vibrantes
      const baseColors = [
        [180, 30, 30],  // Rojo profundo
        [30, 180, 30],  // Verde intenso
        [30, 30, 180],  // Azul eléctrico
        [160, 30, 160], // Púrpura oscuro
        [30, 160, 160], // Cian profundo
        [180, 100, 30]  // Naranja oscuro
      ];

      // Selecciona un color base aleatorio
      const base = baseColors[Math.floor(Math.random() * baseColors.length)];

      // Genera una variación fuerte dentro de un rango oscuro
      const r = Math.max(30, Math.min(200, base[0] + Math.floor(Math.random() * 80 - 40)));
      const g = Math.max(30, Math.min(200, base[1] + Math.floor(Math.random() * 80 - 40)));
      const b = Math.max(30, Math.min(200, base[2] + Math.floor(Math.random() * 80 - 40)));
      const alpha = 0.9;

      color = `rgba(${r}, ${g}, ${b}, ${alpha})`;
      attempts++;

      // Si se generan demasiados intentos sin éxito, se rompe el bucle
      if (attempts > 10) break;

    } while (this.usedColors.has(color)); // Verifica si ya existe en el historial

    // Agrega el color al historial para evitar duplicados
    this.usedColors.add(color);

    return color;
  }

  resetColors(): void {
    this.usedColors.clear(); // Limpia el historial si es necesario
  }



}